<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48"> 
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="赛季赛区">
              <a-cascader :show-search="{ sjsqFilter }" :options="sjsqOptions" :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区" v-model="queryParam.sjsq" changeOnSelect />
            </a-form-item>
          </a-col>
          <a-col :md="(!advanced && 6) || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="
                (advanced && { float: 'right', overflow: 'hidden' }) || {}
              "
            >
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button
                style="margin-left: 8px"
                @click="() => (queryParam = {})"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
 
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd" >新建</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="setAllStatus(1)" key="1">显示</a-menu-item>
          <a-menu-item @click="setAllStatus(2)" key="2">隐藏</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>
    <s-table
        ref="table"
        size="default"
        :columns="columns"
        :data="loadData"
        :alert="false"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
        
      <span slot="status" slot-scope="text,record">
            <a-dropdown :trigger="['click']">
            <a-tag v-if="record.status==1">未开始 <a-icon type="form"/></a-tag>
            <a-tag v-else-if="record.status==2" color="green">进行中 <a-icon type="form"/></a-tag>
            <a-tag v-if="record.status==3">结束 <a-icon type="form"/></a-tag>
            <a-tag v-if="record.status==4" color="red">成绩发布 <a-icon type="form"/></a-tag>
              <a-menu slot="overlay" >
                <a-menu-item key="0" @click="setStatus(1,record)" v-if="record.status==1 || record.status==2">
                  <a>未开始</a>
                </a-menu-item>
                <a-menu-item key="1" @click="setStatus(2,record)" v-if="record.status==1 || record.status==2 || record.status==3">
                  <a>进行中</a>
                </a-menu-item>
                <a-menu-item key="3" @click="setStatus(3,record)" v-if="record.status==2 || record.status==3 || record.status==4">
                  <a>结束</a>
                </a-menu-item>
                <a-menu-item key="4" @click="setStatus(4,record)" v-if=" record.status==4">
                  <a>成绩发布</a>
                </a-menu-item>
              </a-menu>
      </a-dropdown>

 

      </span>

        <span slot="score" slot-scope="text,record">
          <template > 
            {{record.set_win1}}:{{record.set_win2}}
            </template>
        </span>
        <span slot="title1" slot-scope="text,record">
          <template >
             {{record.mingcheng1}}  <br/>
              {{record.mingcheng2}} 
            <br/>
            <a-tag :key="cindex" v-for="(cate,cindex) in record.cates">{{cate.name}}</a-tag>
            </template>
        </span>
        <span slot="update_time" slot-scope="text,record">
          <template >
            {{record.place_name}}<br/> 
            {{record.start_time?moment(record.start_time*1000).format('YYYY-MM-DD HH:mm:ss'):'-'}}<br/>
            </template>
        </span>
         

          <span slot="action" slot-scope="text, record">
            <template>
              <a @click="handleEdit(record)">编辑</a>
              <a-divider type="vertical" />
              <a @click="handleUserManage(record)">裁判设置</a>
              <a-divider type="vertical" />
            </template>
            <a-dropdown>
              <a class="ant-dropdown-link">
                更多 <a-icon type="down" />
              </a>
              <a-menu slot="overlay"> 
                <a-menu-item >
                  <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="onDelete(record)"  okText="确定" cancelText="取消">
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </span>
        </s-table>

    <a-modal
        :maskClosable="false"
            title="操作"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form"> 
          <div >
              <a-form-item
                    label="场地"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
            >
            <a-select
                    showSearch 
                    placeholder="请选择"
                    :defaultActiveFirstOption="false"
                    :filterOption="false" 
                    allowClear
                    v-model="formData.place_id"
                    :notFoundContent="null"
            >
                <a-select-option v-for="option in placeOptions" :key="option.id"  :value="option.id" >{{option.name}}</a-select-option>
            </a-select>
            </a-form-item>

            <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="比赛时间"
                    hasFeedback
            >
            <a-date-picker v-model:value="formData.start_time" placeholder="选择日期" 
            format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss"  />
            </a-form-item>

 
            <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="队伍1"
                    hasFeedback
            >
            {{formData.mingcheng1}}
             <br/>
              <a-tag :key="yindex" v-for="(yitem,yindex) in formData.ydy1">{{yitem}}</a-tag>
            </a-form-item>

            <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="队伍2"
                    hasFeedback
            >
            
            {{formData.mingcheng2}} <br/>
            <a-tag :key="yindex" v-for="(yitem,yindex) in formData.ydy2">{{yitem}}</a-tag>
            </a-form-item>
 
 
            
          </div>
 
        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>


    <a-modal
      :maskClosable="false"
      title="分享"
      v-model="shareShow"
      @ok="shareShow = false"
    > 
      <div class="qrcode" v-if="shareShow" ref="qrcode"></div> 
      <p>文章详情地址</p>
      <p>
        {{ shareUrl }} &nbsp;&nbsp;
        <a
          v-clipboard:copy="shareUrl"
          v-clipboard:success="onCopy2"
          v-clipboard:error="onError"
          >点此复制</a
        >
      </p>
    </a-modal>


 
  </a-card>

</template>

<script>
import STable from '@/components/table/'
import UEditor from '@/components/UEditor/'
import EditableCell from '@/components/EditableCell/'
import RSwitch from '@/components/RSwitch/'
import PicUploader from '@/components/PicUploader/'
import FileUploader from '@/components/FileUploader/'
import ContentPicker from "@/components/ContentPicker/";
import moment from 'moment'
import QRCode from 'qrcodejs2'
import {sjsqOptions, subjectOptions} from '@/api/sai'



import { matchList,matchEdit,placeOptions, matchDetail,setMatchStatus  } from '@/api/vsscore'

import "moment/locale/zh-cn";
moment.locale("zh-cn");

export default {
  name: 'ContentList',
  components: {
    STable,
    EditableCell,
    RSwitch,
    PicUploader,
    FileUploader,
    UEditor,
    ContentPicker,
  },
  data () {
    return {
      visible: false,
      advanced:false,
      saveLoading: false,
      shareShow:false,
      shareUrl:'',
      openKeys: [ ], 
      // 查询参数
      queryParam: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: this.$form.createForm(this),
      sjsqOptions:[],
      mdl: {},
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id'
        },
        {
          title: '队伍',
          dataIndex: 'mingcheng',
          scopedSlots: { customRender: 'title1' },
        },
        {
          title: '局胜',
          dataIndex: 'score',
          scopedSlots: { customRender: 'score' },
        },
        {
          title: '状态',
          dataIndex: 'status',
          filters: [
            {
              text: '未开始',
              value: '1'
            },
            {
              text: '进行中',
              value: '2'
            },
            {
              text: '已结束',
              value: '3'
            }
            ],
          filterMultiple: false,
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '场地时间',
          dataIndex: 'start_time',
          scopedSlots: { customRender: 'update_time' },
          // customRender: (text) =>  {
          //   return moment(text*1000).format('YYYY-MM-DD HH:mm:ss')+'<>';
          // }
        },
        {
          table: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' },
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData');
        console.log(this.queryParam);
        this.queryParam.status = 0;
        this.queryParam = Object.assign(this.queryParam,parameter);
        if(parameter.status && parameter.status.length>0){
          this.queryParam.status =  parameter.status[0];
        }

        this.queryParam.cate_id = 0;
        if (this.queryParam.cate_ids && this.queryParam.cate_ids.length) {
          this.queryParam.cate_id = [...this.queryParam.cate_ids].pop();
        }

        return matchList(this.queryParam)
          .then(res => {
            return res.data
          })

      },
      cateTree: [],
      cateOptions: [],
      selectedRowKeys: [],
      selectedRows: [],
      commentVisible:false,
      activeFormName:1,  
      placeOptions:[ 
      ],
      formData : {
        id:0,
        title: '',
        place_id:"", 
        start_time: '',  
      }
    }
  },
    mounted(){
      let that = this;
      that.getSjsqOptions(); 
    },
  methods: {
    moment, 
    getSjsqOptions() {
      let that = this;
      sjsqOptions({ 
      }).then(res => {
        that.sjsqOptions = res.data;
      });
    },
    setStatus(status, record) {
      let self = this;
      setMatchStatus({
        id: record.id,
        status: status
      })
          .then(res => {
            self.$refs.table.refresh()
          })
          .catch(err => {
            self.$message.error(err.data.msg)
          })
    },
    getPlaceOptions(saiqu) {
      let that = this;
      placeOptions({ 
        saiqu
      }).then(res => {
        that.placeOptions = res.data;
      });
    },
    handleCancel(){
      this.visible = false
    },
    // 增
    handleAdd() {
      let that = this;
      this.visible = true;
      this.form.resetFields();
      console.log('handleAdd');
      that.formData = {
        id:0,
        cate_ids:[],
        project_type:'',
        title: '',
        desc: '',
        pic: [],
        pics: [],
        files: [],
        jingwai_baoming_end: '',
        start_time: '',
        content:'',
        rank:0,
        jingwai_tongzhi_id:0,
        status: 1
      };
      setTimeout( () =>{
        that.form.setFieldsValue({ ...this.formData });
      },100);
    },
    handleFormTabClick(value){
      console.log('handleFormTabClick',this.activeFormName)
    },  
    // 改
    handleEdit(record) {
      let self = this

      matchDetail({ id: record.id }).then(res => {
        setTimeout(()=>{
          self.form.setFieldsValue({ ...res.data })
        },1)
        res.data.start_time = res.data.start_time? moment(res.data.start_time*1000):'';
        self.getPlaceOptions(res.data.saiqu);
        self.formData = Object.assign(self.formData, res.data) //尼玛 日期选择器有bug 必须这样赋值 
        self.formData.id = res.data.id;
      })
      this.visible = true
    },

    onCopy2(e) {
      this.$message.success("复制成功");
    },
    onError(e) {
      this.$message.error("复制失败");
    },
    // 增改 处理
    handleOk(e) {
      let self = this;
      e.preventDefault() 
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.formData)
          self.saveLoading = true;
          let formData = {
            id:self.formData.id, 
            place_id:self.formData.place_id, 
            start_time:self.formData.start_time.format("YYYY-MM-DD HH:mm:ss"), 
          };
          if(self.formData.id) {
            matchEdit(formData).then(res => {
              self.$message.success('修改成功')
              self.$refs.table.refresh(false)
              self.visible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }else{
            addContent(formData).then(res => {
              self.$message.success('新增成功')
              self.$refs.table.refresh(false)
              self.visible = false
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }
        }
      })
    },

    setShow(status, record) {
      let self = this;
      setCommentShow({
        id: record.id,
        show: status
      })
          .then(res => {
            self.fetchCommentList();
          })
          .catch(err => {
            self.$message.error(err.data.msg)
          })
    },
    onDelete(record) {
      let self = this
      deleteContent({ id: record.id }).then(res => {
        self.$message.success('删除成功')
        self.$refs.table.refresh(false)
      }).catch(err =>{
        self.$message.error(err.data.msg)
      })
    },
    onCopy(record) {
      let self = this
      copyContent({ id: record.id }).then(res => {
        self.$message.success('复制成功')
        self.$refs.table.refresh(false)
      }).catch(err =>{
        self.$message.error(err.data.msg)
      })
    }
      ,
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },
    handleCateClick(e){
      let self = this;
      console.log('handleCateClick',e)
      self.queryParam.cate_id = e.key;
      self.$refs.table.refresh(false)
    },

    setAllStatus(status){
      let self = this;
      setContentAllStatus({
        ids:self.selectedRowKeys,
        status:status,
      })
              .then(res => {
                self.$message.success('设置成功')
                self.$refs.table.refresh(false)
              })
    },

    onShare(record){
      this.shareShow = true
      this.shareUrl = record.h5_url
      // new QRCode(this.$refs.qrcode, record.h5_url);
      setTimeout(() =>{
        var qrcode = new QRCode(this.$refs.qrcode, {
              text: record.h5_url, // 需要转换为二维码的内容
              width: 100,
              height: 100,
              colorDark: '#000000',
              colorLight: '#ffffff',
              correctLevel: QRCode.CorrectLevel.H
          }) 
      },200)
    },
    onRankChange(key, dataIndex, value) {
      let self = this;
      setContentRank({
        id: key,
        rank:value
      }).then(res => {
        self.$refs.table.refresh(false)
      }).catch(err =>{
        self.$message.error(err.data.msg)
      })
    },

    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    sjsqFilter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },
  }
}
</script>

<style lang="less">
  .qrcode img{margin: 0 auto;}
  .custom-tree {

    /deep/ .ant-menu-item-group-title {
      position: relative;
      &:hover {
        .btn {
          display: block;
        }
      }
    }

    /deep/ .ant-menu-item {
      &:hover {
        .btn {
          display: block;
        }
      }
    }

    /deep/ .btn {
      display: none;
      position: absolute;
      top: 0;
      right: 10px;
      width: 20px;
      height: 40px;
      line-height: 40px;
      z-index: 1050;

      &:hover {
        transform: scale(1.2);
        transition: 0.5s all;
      }
    }
  }
</style>
